import { FETCH_ROLES, FETCH_USERS, FETCH_USERS_DATA, TASK_DATA } from "../Dispatchers";

const initialState = {
    users: [],
    roles: [],
    masters:[],
    usersData:[]
}
export function AdminReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_USERS:
            return {
                ...state, users: action.payload
            }
        case TASK_DATA:
            return {
                ...state, masters: action.payload
            }
        case FETCH_ROLES:
            return {
                ...state, roles: action.payload
            }
        case FETCH_USERS_DATA:
            return {
                ...state, usersData: action.payload
            }
        default:
            break;
    }
    return state;
}
